import * as React from "react";
const SvgImage20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M1 2h18v16H1V2Zm2 11.414V16h12.586L12 12.414l-1.293 1.293-.707.707-.707-.707L6 10.414l-3 3Zm14 1.172-4.293-4.293L12 9.586l-.707.707L10 11.586 6.707 8.293 6 7.586l-.707.707L3 10.586V4h14v10.586Zm-3.167-9.42a1.833 1.833 0 1 0 0 3.667 1.833 1.833 0 0 0 0-3.666Z",
      clipRule: "evenodd"
    })
  );
export default SvgImage20Px;
